import { InfoClearingToggleCopy } from '@uc/web/shared/data-models';

export const CLEARING_DISABLED_COPY = {
	header_desc_pre_clearing:
		'There are currently no Clearing courses available, as Clearing is yet to open for this year. Discover other [SUBJECT] courses and check back on [DATE] to see the full list of [SUBJECT] Clearing courses.',
	header_desc_post_clearing:
		'Discover other [SUBJECT] courses and check back next year from [DATE] to find out which universities will be offering Clearing courses for [SUBJECT].',
	meta_title: '[SUBJECT] Clearing Courses [YEAR]',
	meta_desc:
		'Compare the best [SUBJECT] undergraduate courses in the UK and check back on [DATE] for Clearing courses - read course reviews, course requirements and more.',
};

export const CLEARING_ENABLED_COPY = {
	header_title: '[SUBJECT] Clearing Courses',
	header_desc:
		'Explore [COURSE_COUNT] [SUBJECT] Clearing courses from [UNI_COUNT] UK universities. Learn more about the entry requirements, filter your search and read reviews from real students to help you decide the best uni for you!',
	meta_title: '[SUBJECT] Clearing Courses [YEAR]',
	meta_desc:
		'Compare the best [SUBJECT] Clearing courses in the UK. Explore [COURSE_COUNT] Clearing courses from [UNI_COUNT] UK universities - read course reviews, course requirements and more.',
};

export const FILTER_CLEARING_TOGGLE_DESC =
	'Only undergraduate courses offered for Clearing [YEAR] will appear and further optimises the search order and next steps available.';

export const INFO_CLEARING_TOGGLE: InfoClearingToggleCopy = {
	clearing_on: {
		title: 'Looking for next year’s courses?',
		desc: "You're looking at Clearing courses for [CURRENT_YEAR] entry. Use the toggle to view undergraduate courses for [NEXT_YEAR] entry.",
	},
	clearing_off: {
		title: 'Looking for clearing [YEAR] courses?',
		desc: "You're looking at undergraduate courses for [NEXT_YEAR] entry. Use the toggle to view Clearing courses for [CURRENT_YEAR] entry.",
	},
};

export const ATHE = 'access-to-higher-education';
